import React from 'react'
import { Trans } from 'react-i18next'
import { Button, Modal, Alert, Form, Row, Col, Spinner } from 'react-bootstrap'
import i18next from 'i18next'

import XLSXParser from './xlsx-parser'
import { exportXLSX } from 'src/components/system_wide/download_xlsx'
import StyledSelect from '../../system_wide/styled_select'

const { t } = i18next

const initialState = {
  errorMsg: '',
  errors: [],
  result: 0,
  show_modal: false,
  dimmed: false,
  brand: null,
  operation_type: 'import',
  loading: false,
  skipped: [],
  imported: [],
}

class ImportDealersModal extends React.Component {
  static defaultProps = {
    importHandler: () => null,
    onSuccess: () => null,
    disabled: false,
    brands: [],
  }
  state = { ...initialState }

  show = () => {
    this.setState({ show_modal: true })
  }
  downloadSkipped = () => {
    let data = [['piva', 'reason']] // header

    this.state.skipped.forEach(item => {
      data.push([item.piva, item.reason])
    })

    exportXLSX(data, 'Skipped_dealers', 'Skipped_dealers.xlsx', { skipHeader: true })
  }

  handleDataReady = async parsedFile => {
    let { importHandler } = this.props
    // this.setState({ dimmed: true })
    let data = { dealers: parsedFile, brand: this.state.brand, operation_type: this.state.operation_type }
    this.setState({ loading: true }, async () => {
      let { imported = [], skipped = [], error = '' } = await importHandler(data)
      this.setState({ imported, skipped, loading: false, errorMsg: error })
    })
  }

  handleDismiss = () => {
    this.setState({ ...initialState })
  }

  handleSelectChange = (option, { name }) => {
    this.setState({ [name]: option ? option.value : null })
  }
  handleOperationTypeChange = e => {
    this.setState({ operation_type: e.target.value })
  }

  render() {
    let { brands } = this.props
    let { brand, dimmed, operation_type, loading, imported, skipped, errorMsg } = this.state
    const brandOptions = brands.map(b => ({ label: b.name, value: b.id }))
    const selected_brand = brandOptions.find(b => b.value === brand) ?? null
    return (
      <Modal backdrop="static" centered size="xl" show={this.state.show_modal} onHide={this.handleDismiss}>
        <Modal.Header>
          <Modal.Title>
            <Trans i18nKey="components.dealers.import_dealers.title">Importa dealer</Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ position: 'relative' }}>
          {loading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          <div className="p-3 mb-0 text-muted">
            <Trans i18nKey="components.dealers.import_dealers.usage_message">
              Per importare l’elenco dei dealer è necessario selezionare il brand di riferimento e il tipo di
              operazione, caricare il file Excel (.xlsx), effettuare il mapping delle colonne e infine cliccare su
              "Procedi" per completare l’importazione.
            </Trans>
          </div>
          <>
            {(imported.length > 0 || skipped.length > 0) && (
              <>
                <Alert variant="success" dismissible onClose={this.handleDismiss}>
                  <Trans i18nKey="system_wide.bulk_import.modal_file_import_success">
                    <b>Importazione completata</b>
                  </Trans>
                  <p>
                    <Trans i18nKey="system_wide.bulk_import.imported_rows">Righe importate correttamente:</Trans>
                    <b> {this.state.imported.length}</b>
                  </p>
                </Alert>

                {skipped.length > 0 && (
                  <Alert variant="danger" dismissible onClose={this.handleDismiss}>
                    <Trans i18nKey="system_wide.bulk_import.modal_file_import_skipped">
                      <b>Alcune righe sono state saltate</b>
                    </Trans>
                    <p>
                      <Trans i18nKey="system_wide.bulk_import.skipped_lines">Righe saltate:</Trans>
                      <b> {this.state.skipped.length}</b>
                    </p>
                    <hr />
                    <button className="btn btn-secondary" onClick={this.downloadSkipped}>
                      <i className="fas fa-download fa-fw text-start" />
                      <Trans i18nKey="system_wide.bulk_import.download_skipped_button">
                        Scarica report righe saltate
                      </Trans>
                    </button>
                  </Alert>
                )}
              </>
            )}
            {imported.length === 0 && skipped.length === 0 && (
              <>
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label>
                      <Trans i18nKey="components.dealers.brand">Brand</Trans>
                      <span> *</span>
                    </Form.Label>

                    <StyledSelect
                      name="brand"
                      placeholder={t('components.dealers.brand', 'Brand')}
                      value={selected_brand}
                      onChange={this.handleSelectChange}
                      options={brandOptions}
                    />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label>
                      <Trans i18nKey="components.dealers.operationType">Tipo operazione *</Trans>
                    </Form.Label>

                    <div>
                      <Form.Check
                        type="radio"
                        id="import_new"
                        name="operation_type"
                        label={t('components.dealers.import_new', 'Importa nuovi valori')}
                        value="import"
                        checked={operation_type === 'import'}
                        onChange={this.handleOperationTypeChange}
                      />

                      <Form.Check
                        type="radio"
                        id="modify_existing"
                        name="operation_type"
                        label={t('components.dealers.modify_existing', 'Modifica esistenti')}
                        value="modify"
                        checked={operation_type === 'modify'}
                        onChange={this.handleOperationTypeChange}
                      />
                    </div>
                  </Form.Group>
                </Row>
                {errorMsg === '' && selected_brand && (
                  <Alert variant="light" className="mb-0">
                    <Alert.Heading className="mb-4">
                      <Trans i18nKey="system_wide.bulk_import.modal_import_upload_file">
                        Carica il file excel (.xlsx)
                      </Trans>
                    </Alert.Heading>
                    <XLSXParser onDataReady={this.handleDataReady} dimmed={dimmed} operationType={operation_type} />
                  </Alert>
                )}
                {errorMsg !== '' && (
                  <Alert variant="danger" dismissible onClose={() => this.setState({ errorMsg: '' })}>
                    {errorMsg}{' '}
                  </Alert>
                )}
              </>
            )}
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleDismiss} variant="secondary" disabled={this.state.loading}>
            <Trans i18nKey="button_close">Chiudi</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ImportDealersModal
